@if (currentTime || currentTime === 0) {
  <ng-container *ngTemplateOutlet="timeTpl; context: { hrs: ctf.hrs, min: ctf.min, sec: ctf.sec }"></ng-container>
}
@if ((currentTime || currentTime === 0) && duration) {
  /
}
@if (duration) {
  <ng-container *ngTemplateOutlet="timeTpl; context: { hrs: dtf.hrs, min: dtf.min, sec: dtf.sec }"></ng-container>
}

<ng-template #timeTpl let-hrs="hrs" let-min="min" let-sec="sec">
  @if (hrs !== '0') {
    {{ hrs }} :
  }
  {{ min }} : {{ sec }}
</ng-template>
